/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AddressResultResource } from './';
import {
    AddressResultResourceFromJSON,
    AddressResultResourceFromJSONTyped,
    AddressResultResourceToJSON,
} from './';
import type { LegalPersonResultResource } from './';
import {
    LegalPersonResultResourceFromJSON,
    LegalPersonResultResourceFromJSONTyped,
    LegalPersonResultResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface SubcontractorCompanyResultResource
 */
export interface SubcontractorCompanyResultResource {
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    companyId: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    accountId: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    identityId: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    email: string;
    /**
     * 
     * @type {AddressResultResource}
     * @memberof SubcontractorCompanyResultResource
     */
    address?: AddressResultResource;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    registrationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    vatIdentificationNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    companyTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    companyTypeName?: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    creatorAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    complianceStatus: SubcontractorCompanyResultResourceComplianceStatusEnum;
    /**
     * 
     * @type {LegalPersonResultResource}
     * @memberof SubcontractorCompanyResultResource
     */
    legalPerson?: LegalPersonResultResource;
    /**
     * 
     * @type {Date}
     * @memberof SubcontractorCompanyResultResource
     */
    lastUpdateDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubcontractorCompanyResultResource
     */
    lastConnectionDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubcontractorCompanyResultResource
     */
    creationDate: Date;
    /**
     * 
     * @type {number}
     * @memberof SubcontractorCompanyResultResource
     */
    carriedFreelancersCount: number;
    /**
     * 
     * @type {number}
     * @memberof SubcontractorCompanyResultResource
     */
    projectsCount: number;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    kind: SubcontractorCompanyResultResourceKindEnum;
    /**
     * 
     * @type {string}
     * @memberof SubcontractorCompanyResultResource
     */
    photoUrl?: string;
}


/**
 * @export
 */
export const SubcontractorCompanyResultResourceComplianceStatusEnum = {
    NotCompliant: 'NOT_COMPLIANT',
    Pending: 'PENDING',
    Compliant: 'COMPLIANT'
} as const;
export type SubcontractorCompanyResultResourceComplianceStatusEnum = typeof SubcontractorCompanyResultResourceComplianceStatusEnum[keyof typeof SubcontractorCompanyResultResourceComplianceStatusEnum];

/**
 * @export
 */
export const SubcontractorCompanyResultResourceKindEnum = {
    Agency: 'AGENCY',
    Umbrella: 'UMBRELLA'
} as const;
export type SubcontractorCompanyResultResourceKindEnum = typeof SubcontractorCompanyResultResourceKindEnum[keyof typeof SubcontractorCompanyResultResourceKindEnum];


/**
 * Check if a given object implements the SubcontractorCompanyResultResource interface.
 */
export function instanceOfSubcontractorCompanyResultResource(value: object): value is SubcontractorCompanyResultResource {
    if (!('companyId' in value) || value['companyId'] === undefined) return false;
    if (!('accountId' in value) || value['accountId'] === undefined) return false;
    if (!('identityId' in value) || value['identityId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('creatorAccountId' in value) || value['creatorAccountId'] === undefined) return false;
    if (!('complianceStatus' in value) || value['complianceStatus'] === undefined) return false;
    if (!('lastUpdateDate' in value) || value['lastUpdateDate'] === undefined) return false;
    if (!('lastConnectionDate' in value) || value['lastConnectionDate'] === undefined) return false;
    if (!('creationDate' in value) || value['creationDate'] === undefined) return false;
    if (!('carriedFreelancersCount' in value) || value['carriedFreelancersCount'] === undefined) return false;
    if (!('projectsCount' in value) || value['projectsCount'] === undefined) return false;
    if (!('kind' in value) || value['kind'] === undefined) return false;
    return true;
}

export function SubcontractorCompanyResultResourceFromJSON(json: any): SubcontractorCompanyResultResource {
    return SubcontractorCompanyResultResourceFromJSONTyped(json, false);
}

export function SubcontractorCompanyResultResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubcontractorCompanyResultResource {
    if (json == null) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'accountId': json['accountId'],
        'identityId': json['identityId'],
        'name': json['name'] == null ? undefined : json['name'],
        'email': json['email'],
        'address': json['address'] == null ? undefined : AddressResultResourceFromJSON(json['address']),
        'registrationNumber': json['registrationNumber'] == null ? undefined : json['registrationNumber'],
        'vatIdentificationNumber': json['vatIdentificationNumber'] == null ? undefined : json['vatIdentificationNumber'],
        'companyTypeId': json['companyTypeId'] == null ? undefined : json['companyTypeId'],
        'companyTypeName': json['companyTypeName'] == null ? undefined : json['companyTypeName'],
        'creatorAccountId': json['creatorAccountId'],
        'complianceStatus': json['complianceStatus'],
        'legalPerson': json['legalPerson'] == null ? undefined : LegalPersonResultResourceFromJSON(json['legalPerson']),
        'lastUpdateDate': (new Date(json['lastUpdateDate'])),
        'lastConnectionDate': (new Date(json['lastConnectionDate'])),
        'creationDate': (new Date(json['creationDate'])),
        'carriedFreelancersCount': json['carriedFreelancersCount'],
        'projectsCount': json['projectsCount'],
        'kind': json['kind'],
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
    };
}

export function SubcontractorCompanyResultResourceToJSON(value?: SubcontractorCompanyResultResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'companyId': value['companyId'],
        'accountId': value['accountId'],
        'identityId': value['identityId'],
        'name': value['name'],
        'email': value['email'],
        'address': AddressResultResourceToJSON(value['address']),
        'registrationNumber': value['registrationNumber'],
        'vatIdentificationNumber': value['vatIdentificationNumber'],
        'companyTypeId': value['companyTypeId'],
        'companyTypeName': value['companyTypeName'],
        'creatorAccountId': value['creatorAccountId'],
        'complianceStatus': value['complianceStatus'],
        'legalPerson': LegalPersonResultResourceToJSON(value['legalPerson']),
        'lastUpdateDate': ((value['lastUpdateDate']).toISOString()),
        'lastConnectionDate': ((value['lastConnectionDate']).toISOString()),
        'creationDate': ((value['creationDate']).toISOString()),
        'carriedFreelancersCount': value['carriedFreelancersCount'],
        'projectsCount': value['projectsCount'],
        'kind': value['kind'],
        'photoUrl': value['photoUrl'],
    };
}

